module.exports = __webpack_public_path__ + "img/error.4ef4bf74.png";